import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelTurkish_f: KeyLabel[] = [
  {
    code: 4,
    label: 'U',
    meta: [
      {
        label: 'Æ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 5,
    label: 'Ç',
  },
  {
    code: 6,
    label: 'V',
    meta: [
      {
        label: '¢',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '©',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '©',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 7,
    label: 'E',
    meta: [
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 8,
    label: 'Ğ',
  },
  {
    code: 9,
    label: 'A',
    meta: [
      {
        label: 'ª',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'ª',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 10,
    label: 'Ü',
  },
  {
    code: 11,
    label: 'T',
    meta: [
      {
        label: '₺',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 12,
    label: 'N',
  },
  {
    code: 13,
    label: 'K',
  },
  {
    code: 14,
    label: 'M',
  },
  {
    code: 15,
    label: 'L',
  },
  {
    code: 16,
    label: 'S',
    meta: [
      {
        label: 'µ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'º',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'º',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 17,
    label: 'Z',
  },
  {
    code: 18,
    label: 'H',
    meta: [
      {
        label: 'Ø',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 19,
    label: 'P',
    meta: [
      {
        label: '£',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 20,
    label: 'F',
    meta: [
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 21,
    label: 'I',
    meta: [
      {
        label: '¶',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 22,
    label: 'İ',
    meta: [
      {
        label: 'ß',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '§',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '§',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 23,
    label: 'O',
  },
  {
    code: 24,
    label: 'R',
  },
  {
    code: 25,
    label: 'C',
  },
  {
    code: 26,
    label: 'G',
  },
  {
    code: 27,
    label: 'Ö',
    meta: [
      {
        label: '»',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 28,
    label: 'D',
    meta: [
      {
        label: '¥',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 29,
    label: 'J',
    meta: [
      {
        label: '«',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¹',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '²',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '^ (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '^ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '³',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '³',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: '$',
        modifiers: MOD.SFT,
      },
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¼',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¤',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¤',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '½',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: '&',
        modifiers: MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¾',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: "'",
        modifiers: MOD.SFT,
      },
      {
        label: "'",
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '[',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: ']',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 39,
    label: '0',
    meta: [
      {
        label: '=',
        modifiers: MOD.SFT,
      },
      {
        label: '=',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: '/',
    meta: [
      {
        label: '(backslash)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¿',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¿',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: 'Q',
    meta: [
      {
        label: '¨ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: 'W',
    meta: [
      {
        label: '~ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 50,
    label: 'X',
    meta: [
      {
        label: '` (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 51,
    label: 'Y',
    meta: [
      {
        label: '´ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 52,
    label: 'Ş',
  },
  {
    code: 53,
    label: '+',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¬',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 54,
    label: 'B',
    meta: [
      {
        label: '×',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 55,
    label: '.',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '÷',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 56,
    label: ',',
    meta: [
      {
        label: ';',
        modifiers: MOD.SFT,
      },
      {
        label: ';',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '(soft hyphen)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 100,
    label: '<',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¦',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¦',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 512,
    label: '®',
  },
  {
    code: 542,
    label: '!',
  },
  {
    code: 543,
    label: '"',
  },
  {
    code: 544,
    label: '^ (dead)',
  },
  {
    code: 545,
    label: '$',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: '&',
  },
  {
    code: 548,
    label: "'",
  },
  {
    code: 549,
    label: '(',
  },
  {
    code: 550,
    label: ')',
  },
  {
    code: 551,
    label: '=',
  },
  {
    code: 558,
    label: '_',
  },
  {
    code: 565,
    label: '*',
  },
  {
    code: 565,
    label: '?',
  },
  {
    code: 567,
    label: ':',
  },
  {
    code: 568,
    label: ';',
  },
  {
    code: 612,
    label: '>',
  },
  {
    code: 4608,
    label: '®',
  },
  {
    code: 4638,
    label: '!',
  },
  {
    code: 4639,
    label: '"',
  },
  {
    code: 4640,
    label: '^ (dead)',
  },
  {
    code: 4641,
    label: '$',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: '&',
  },
  {
    code: 4644,
    label: "'",
  },
  {
    code: 4645,
    label: '(',
  },
  {
    code: 4646,
    label: ')',
  },
  {
    code: 4647,
    label: '=',
  },
  {
    code: 4654,
    label: '_',
  },
  {
    code: 4661,
    label: '*',
  },
  {
    code: 4661,
    label: '?',
  },
  {
    code: 4663,
    label: ':',
  },
  {
    code: 4664,
    label: ';',
  },
  {
    code: 4708,
    label: '>',
  },
  {
    code: 5124,
    label: 'Æ',
  },
  {
    code: 5126,
    label: '¢',
  },
  {
    code: 5127,
    label: '€',
  },
  {
    code: 5131,
    label: '₺',
  },
  {
    code: 5136,
    label: 'µ',
  },
  {
    code: 5138,
    label: 'Ø',
  },
  {
    code: 5139,
    label: '£',
  },
  {
    code: 5140,
    label: '@',
  },
  {
    code: 5141,
    label: '¶',
  },
  {
    code: 5142,
    label: 'ß',
  },
  {
    code: 5147,
    label: '»',
  },
  {
    code: 5148,
    label: '¥',
  },
  {
    code: 5149,
    label: '«',
  },
  {
    code: 5150,
    label: '¹',
  },
  {
    code: 5151,
    label: '²',
  },
  {
    code: 5152,
    label: '#',
  },
  {
    code: 5153,
    label: '¼',
  },
  {
    code: 5154,
    label: '½',
  },
  {
    code: 5155,
    label: '¾',
  },
  {
    code: 5156,
    label: '{',
  },
  {
    code: 5157,
    label: '[',
  },
  {
    code: 5158,
    label: ']',
  },
  {
    code: 5159,
    label: '}',
  },
  {
    code: 5165,
    label: '(backslash)',
  },
  {
    code: 5166,
    label: '|',
  },
  {
    code: 5167,
    label: '¨ (dead)',
  },
  {
    code: 5168,
    label: '~ (dead)',
  },
  {
    code: 5170,
    label: '` (dead)',
  },
  {
    code: 5171,
    label: '´ (dead)',
  },
  {
    code: 5173,
    label: '¬',
  },
  {
    code: 5174,
    label: '×',
  },
  {
    code: 5175,
    label: '÷',
  },
  {
    code: 5176,
    label: '(soft hyphen)',
  },
  {
    code: 5638,
    label: '©',
  },
  {
    code: 5638,
    label: '©',
  },
  {
    code: 5641,
    label: 'ª',
  },
  {
    code: 5641,
    label: 'ª',
  },
  {
    code: 5648,
    label: 'º',
  },
  {
    code: 5648,
    label: 'º',
  },
  {
    code: 5654,
    label: '§',
  },
  {
    code: 5654,
    label: '§',
  },
  {
    code: 5664,
    label: '³',
  },
  {
    code: 5664,
    label: '³',
  },
  {
    code: 5665,
    label: '¤',
  },
  {
    code: 5665,
    label: '¤',
  },
  {
    code: 5677,
    label: '¿',
  },
  {
    code: 5677,
    label: '¿',
  },
  {
    code: 5732,
    label: '¦',
  },
  {
    code: 5732,
    label: '¦',
  },
];
